export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5235.a0d73d2b.jpg";